export const API = {
  URL: import.meta.env.VITE_API_URL as string,
  HOST: import.meta.env.VITE_API_HOST as string,
  CRM_REST_URL: import.meta.env.VITE_CRM_REST_API_URL as string,
  CRM_UI_URL: import.meta.env.VITE_CRM_UI_URL as string,
};
